import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import styles from '../../assets/stylesheets/pages/sale_products/sale_products.module.scss'

import CurrencyUSD from '../misc/currency_formats'
// import { Checkbox } from 'lensrentals-components'
import { Button } from 'lensrentals-components'

import { NumberRatingScaleRating } from './rating_scale_rating'
import useSaleCart from '../helpers/use_sale_cart'
import { getExtraItems, getMissingItems } from '../helpers/sale_listing_helpers'

export default function SaleListings({ saleListings, onChangeListing, sortedRatingScales, selectedListingId }) {
  const [saleCart, updateSaleCart] = useSaleCart()
  const {
    loading,
    updating,
    plan: salePlan
  } = saleCart

  const addToCart = id => event => {
    event.preventDefault()
    return updateSaleCart(salePlan.withItemsUpdated({
      ...salePlan.cartObject,
      // newlyAdded flag is so analytics can grab this server side
      id: { saleListing: { id: id }, quantity: 1, hasWarranty: false, newlyAdded: true }
    }))
  }

  return (
    <>
      <a
        className={styles['faq-link']}
        href="https://help.lensrentals.com/26472-keeper/what-do-the-keeper-ratings-mean"
        target="_blank"
      >
        What do the Keeper ratings mean?
      </a>
      <div className={styles['listings-table']}>
        <table>
          <thead>
            <tr>
              <th />{/* a blank header for the select column */}
              {sortedRatingScales.map(scale => <th key={scale.id} data-column-name={scale.name}>{scale.name}</th>)}
              <th data-column-name='Price'>Price</th>
            </tr>
          </thead>
          <tbody>
            {saleListings.map(saleListing => {
              const selected = selectedListingId === saleListing.id
              const description = saleListing?.description || saleListing.discriminator?.description
              const extraItems = getExtraItems(saleListing)
              const missingItems = getMissingItems(saleListing)

              return (
                <tr
                  key={saleListing.id}
                  onClick={() => onChangeListing(saleListing.id)}
                  className={cx('saleListing-row', selected && styles['listings-row-selected'])}
                >
                  <td>
                    <input
                      type='radio'
                      name='selected-product'
                      id={saleListing.id}
                      value={saleListing.id}
                      checked={selected}
                      onChange={() => onChangeListing(saleListing.id)}
                    />
                  </td>

                  <SaleRatingScales
                    scales={sortedRatingScales}
                    saleListing={saleListing}
                    description={description}
                  />

                  {!!description && (
                    <td
                      className={styles['selected-only']}
                      data-column-name='Description'
                    >
                      {description}
                    </td>
                  )}

                  {!!missingItems?.length && (
                    <td
                      className={styles['selected-only']}
                      data-column-name='missing'
                    >
                      <span>Items NOT Included: </span> {missingItems.map((item) => item.fullName).join(', ')}
                    </td>
                  )}

                  {!!extraItems?.length && (
                    <td
                      className={styles['selected-only']}
                      data-column-name='extra'
                    >
                      <span>Extra Items Included: </span> {extraItems.map((item) => item.fullName).join(', ')}
                    </td>
                  )}

                  <td data-column-name='Price'>
                    <CurrencyUSD amount={saleListing.price} />
                  </td>
                  <td>
                    {
                      salePlan?.cart.find(item => item.saleListing.id === saleListing.id)
                        // ? <a href='/cart?active=sale' id='view-cart'>View In Cart</a>
                        ? <Button href='/cart?active=sale' id='view-cart' color='highlight'>View In Cart</Button>
                        : <Button onClick={addToCart(selectedListingId)} id='sale-listing-add-to-cart' color='confirm'>Add to Cart</Button>
                    }
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}

function SaleRatingScales({ scales, saleListing, description }) {
  return scales.map((scale) => {
    const ratingIds = saleListing.ratings.map(rating => rating.id)
    const rating = scale.ratings.find(rating => ratingIds.includes(rating.id))
    if (['Cosmetic', 'Performance', 'Glass'].includes(scale.name)) {
      return (
        <NumberRatingScaleRating
          key={`${saleListing.id}_${scale.id}`}
          rating={rating}
          columnName={scale.name}
        />
      )
    } else {
      return (
        <td
          key={`${saleListing.id}_${scale.id}`}
          data-column-name={scale.name}
          className={cx(scale.name === 'Overall' && description && styles['has-description'])}
        >
          {rating.name}
        </td>
      )
    }
  })
}

SaleListings.propTypes = {
  sortedRatingScales: PropTypes.array.isRequired,
  saleListings: PropTypes.array.isRequired,
  onChangeListing: PropTypes.func.isRequired,
  selectedListingId: PropTypes.string
}
